export enum MessageActor {
  USER = 'user',
  CLARA = 'clara',
  SYSTEM = 'system'
}